var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardBox',{attrs:{"placement":"right","position":"left","width":300},on:{"expand":_vm.toggleHandler}},[_c('CardItem',{attrs:{"title":_vm.$t('flowchart.L10101'),"enableFold":true,"bold":true}},[_c('Options')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }